import { createPortal } from 'react-dom';
import Banner from '@components/ui/Banner/Banner';
import { useNotificationStore } from '@stores/notificationStore';
import styles from './NotificationContainer.module.scss';

function NotificationContainer() {
  const notifications = useNotificationStore((s) => s.notifications);
  const removeNotification = useNotificationStore((s) => s.removeNotification);

  if (notifications.length === 0) return null;

  return createPortal(
    <div className={styles.container}>
      {notifications.map((n) => (
        <Banner
          key={n.id}
          variant={n.variant}
          title={n.title}
          description={n.description}
          dismissible
          onDismiss={() => removeNotification(n.id)}
        />
      ))}
    </div>,
    document.body,
  );
}

export default NotificationContainer;
